<template>
	<span>
		<Enter2FA ref="enter2FA" :callback="codeEntered" @resend="submit" />
		<b-container>
			<b-row align-v="center" class="vh-100">
				<b-col>
					<b-card style="width:26rem" class="mx-auto bg-none border-none my-auto">
						<p v-if="showSuccessMessage">
							{{ $t("passwordreset.reset-successful") }}
							<router-link to="/signin">
								{{ $t("passwordreset.back-link-success") }}
							</router-link>
						</p>
						<b-form v-else @submit.prevent="submit">
							<p>
								{{ $t("passwordreset.info-text") }}
							</p>
							<p class="text-danger">
								{{ errortext }}
							</p>
							<b-form-group :label="$t('passwordreset.label-text')" label-for="login">
								<b-form-input
									id="login"
									v-model="form.email"
									type="email"
									required
									:placeholder="$t('passwordreset.field-placeholder')"
								/>
							</b-form-group>
							<b-form-group>
								<b-button type="submit" variant="primary" block>
									{{ $t("passwordreset.button-text") }}
								</b-button>
							</b-form-group>
							<b-form-group>
								<div class="text-center">
									<router-link to="/signin">
										{{ $t("passwordreset.back-link") }}
									</router-link>
								</div>
							</b-form-group>
						</b-form>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
	</span>
</template>

<script>
import Enter2FA from '@/views/user/Enter2FA.vue';

export default {
	name: 'ResetPassword',
	components: {
		Enter2FA,
	},
	data: () => ({
		authToken: null,
		secondFactorRequired: false,
		secondFactor: null,
		showSuccessMessage: false,
		form: {
			email: '',
		},
		errortext: '',
	}),
	methods: {
		submit() {
			this.axios
				.post('/passwordreset', {
					email: this.form.email,
					secondFactor: this.secondFactor,
					authToken: this.authToken,
				})
				.then((response) => {
					this.authToken = '';
					this.secondFactor = '';
					this.errortext = '';
					if (response.data.success) {
						this.$refs.enter2FA.hide();
						this.showSuccessMessage = true;
					} else if (response.data.secondFactorRequired) {
						this.secondFactorRequired = true;
						this.authToken = response.data.authToken;
						this.$refs.enter2FA.show();
					}
				})
				.catch(() => {
					this.authToken = '';
					this.secondFactor = '';
					this.errortext = this.$t('passwordreset.reset-failed');
					this.$refs.enter2FA.hide();
				});
		},
		codeEntered(code) {
			this.secondFactor = code;
			this.submit();
		},
	},
};
</script>
